function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1338 14.4225H25.4825V13.7979H24.139V13.2302C24.2286 12.4834 24.4282 12.0275 24.7387 11.8622C25.0834 11.7007 25.4347 11.7159 25.7931 11.9086C25.886 11.6505 25.9618 11.4493 26.0201 11.3049C25.6551 11.0847 25.3176 11.0108 25.007 11.0828C24.4007 11.1036 23.9593 11.3996 23.6839 11.9706C23.5047 12.2666 23.4098 12.6454 23.3994 13.1061V18.8788C23.6308 18.7542 23.8749 18.6297 24.1333 18.5047V14.4225H24.1338Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3218 11.124H27.5879V17.1775C27.8259 17.1055 28.0705 17.0345 28.3218 16.9648V11.124Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9956 15.8209V13.1782H30.2617V15.9038C30.2617 16.1112 30.2679 16.3049 30.2802 16.4857C30.5163 16.4351 30.7586 16.3863 31.0051 16.338C30.9989 16.1827 30.9956 16.0117 30.9956 15.8209Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2238 13.1782H34.4795V15.8072C34.7236 15.7792 34.9721 15.7527 35.2238 15.7276V13.1782Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M42.1621 13.3228H41.3818L40.418 15.4327C40.6754 15.4285 40.9361 15.4256 41.1993 15.4237L42.1621 13.3228Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37.6033 13.3228H36.8281L37.8436 15.5256C38.0925 15.5118 38.3452 15.4995 38.6007 15.4881L37.6033 13.3228Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M44.422 13.3125H43.6934V15.4135C43.9385 15.4092 44.1817 15.404 44.422 15.3974V13.3125Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M51.3234 13.1782H50.5791V14.8999C50.8304 14.8649 51.0783 14.8275 51.3234 14.7891V13.1782Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M47.0972 13.1782H46.3633V15.3133C46.6108 15.2986 46.8549 15.2821 47.0972 15.2645V13.1782Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0964 13.9476C54.2652 13.7927 54.4686 13.7151 54.7061 13.7151C54.9388 13.7151 55.1768 13.7913 55.4196 13.9424C55.6941 13.8704 55.9629 13.7961 56.2274 13.7198C55.7263 13.2643 55.2295 13.0337 54.7374 13.0337C54.2931 13.0337 53.9234 13.1757 53.629 13.4594C53.3516 13.7269 53.2065 14.0598 53.1904 14.4566C53.4189 14.4107 53.6451 14.3638 53.8674 14.315C53.9025 14.1787 53.9784 14.056 54.0964 13.9476Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1333 18.9855V18.5049C23.8749 18.6294 23.6303 18.7544 23.3994 18.879V18.986H24.1333V18.9855Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3218 18.9754V16.9648C28.0705 17.0345 27.8254 17.105 27.5879 17.1775V18.9754H28.3218Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3631 18.6477C31.7319 18.8698 32.1937 18.9806 32.7484 18.9806C33.2997 18.9806 33.7577 18.8698 34.1232 18.6477C34.4882 18.4256 34.7632 18.1178 34.9476 17.7239C35.132 17.3299 35.224 16.7423 35.224 15.961V15.7275C34.9723 15.7526 34.7239 15.7792 34.4797 15.8071V15.8213C34.4797 16.5301 34.4418 16.9932 34.3659 17.2101C34.2593 17.5302 34.0644 17.7883 33.7819 17.9843C33.4993 18.1804 33.1546 18.2788 32.7484 18.2788C32.3383 18.2788 31.987 18.178 31.694 17.9767C31.401 17.7755 31.2028 17.5009 31.0995 17.1533C31.0507 16.9833 31.0198 16.7106 31.0051 16.3384C30.7586 16.3862 30.5164 16.4354 30.2803 16.4861C30.3154 17.0065 30.4002 17.4161 30.5358 17.7135C30.7188 18.1145 30.9942 18.4256 31.3631 18.6477Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5675 18.9856L41.1993 15.4238C40.9362 15.4257 40.675 15.4286 40.418 15.4328L39.5002 17.442L38.6009 15.4887C38.3453 15.4996 38.0926 15.5124 37.8438 15.5261L39.4386 18.9861H39.5675V18.9856Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M44.422 18.9754V15.3975C44.1812 15.4041 43.9385 15.4098 43.6934 15.4136V18.9749H44.422V18.9754Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M46.6363 17.7135C46.8189 18.1146 47.0948 18.4257 47.4631 18.6478C47.832 18.8698 48.2937 18.9806 48.8484 18.9806C49.3998 18.9806 49.8582 18.8698 50.2233 18.6478C50.5883 18.4257 50.8633 18.1179 51.0477 17.7239C51.2321 17.33 51.3241 16.7423 51.3241 15.961V14.7896C51.079 14.8279 50.8315 14.8648 50.5798 14.9004V15.8218C50.5798 16.5307 50.5418 16.9938 50.466 17.2102C50.3588 17.5303 50.1645 17.7883 49.8819 17.9844C49.5994 18.1804 49.2547 18.2784 48.8484 18.2784C48.4383 18.2784 48.087 18.1776 47.794 17.9763C47.5011 17.7751 47.3029 17.5004 47.1995 17.1529C47.1303 16.9119 47.0962 16.4682 47.0962 15.8209V15.2645C46.8539 15.282 46.6098 15.2986 46.3623 15.3133V15.9037C46.3628 16.7097 46.4538 17.3124 46.6363 17.7135Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M53.466 15.4083C53.6485 15.6697 53.9965 15.9296 54.5099 16.1877C54.9854 16.432 55.2903 16.6352 55.4244 16.7966C55.5591 16.9586 55.6259 17.1442 55.6259 17.354C55.6259 17.6054 55.5235 17.8246 55.3182 18.0121C55.113 18.1997 54.866 18.2934 54.5768 18.2934C54.1596 18.2934 53.7651 18.0836 53.3935 17.6636L52.9336 18.185C53.1265 18.4364 53.3721 18.6315 53.6699 18.7707C53.9681 18.9104 54.2805 18.98 54.6081 18.98C55.0973 18.98 55.5046 18.819 55.8303 18.4975C56.156 18.176 56.3186 17.7844 56.3186 17.3232C56.3186 16.9927 56.2238 16.6948 56.0341 16.4301C55.8412 16.1687 55.4723 15.8984 54.9281 15.6195C54.4834 15.3922 54.1923 15.1909 54.0543 15.0153C53.9131 14.85 53.8424 14.6781 53.8424 14.4991C53.8424 14.4347 53.851 14.3736 53.8661 14.3145C53.6438 14.3632 53.4176 14.4101 53.1891 14.456C53.1882 14.4807 53.1858 14.5048 53.1858 14.5299C53.1868 14.8614 53.2797 15.154 53.466 15.4083Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9451 5.87065L44.291 3.63424L38.6006 1.00101V0L45.2013 3.00541C45.4497 3.11858 45.609 3.36623 45.609 3.6385C45.609 3.90319 45.4587 4.14516 45.2207 4.26259L39.9451 6.86504V5.87065Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1187 10.3367L34.5176 7.34411C34.2696 7.23189 34.1104 6.98471 34.1104 6.71244C34.1104 6.44727 34.2616 6.2053 34.5 6.08929L39.8705 3.47217V4.47318L35.4288 6.72286L41.1192 9.34282V10.3367H41.1187Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M33.231 38.9613C33.8672 38.9092 34.5105 38.8396 35.1482 38.8012C35.7816 38.7804 36.4168 38.7595 37.0535 38.7387C37.3702 38.7311 37.6826 38.7207 37.9946 38.7094L40.0341 32.7653L42.0063 38.545C44.2274 38.6161 46.4451 38.779 48.6212 38.779C48.6226 38.779 48.624 38.779 48.6255 38.779L43.4632 25.5205H36.6406L31.3408 39.2212C31.968 39.1625 32.5981 39.0167 33.231 38.9613Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M67.148 43.1282C68.5702 43.2314 68.118 43.3314 68.3929 43.4431C69.298 43.7807 70.3628 44.1041 71.1877 44.4119C72.0097 44.724 72.8982 45.1104 73.6169 45.4238C73.7909 45.5034 74.2593 45.5768 74.2593 45.6535V30.2562H79.0001V25.521H61.459V30.2562H67.148V43.1282Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M2.88754 37.6333C3.75369 38.3545 4.80094 38.7873 7.47194 39.5799C10.3961 40.4455 11.2262 41.0583 11.2262 42.3562C11.2262 43.1682 10.819 43.816 10.1287 44.2251C10.2197 44.191 10.3017 44.1489 10.3947 44.1172C11.2219 43.816 12.0924 43.4992 13.0002 43.1692C13.4554 43.0044 13.9195 42.8363 14.3931 42.6649C14.8748 42.5209 15.3659 42.3746 15.8651 42.2255C16.4805 42.0484 17.1129 41.8665 17.7529 41.6823C17.7539 41.6175 17.7605 41.5569 17.7605 41.491C17.7605 37.9217 16.0277 35.9746 11.8406 34.7487C9.02504 33.9195 8.77187 33.8116 8.08635 33.2343C7.7251 32.946 7.50844 32.4772 7.50844 32.0444C7.50844 30.8545 8.66378 29.9534 10.1799 29.9534C11.6235 29.9534 12.8874 30.4581 14.295 31.5761L16.7858 26.7083C14.3675 25.4464 11.696 24.7617 9.16868 24.7617C4.2951 24.7617 0.974609 28.0427 0.974609 32.8745C0.974609 35.001 1.62458 36.5873 2.88754 37.6333Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4478 41.1096C45.9698 40.8435 43.4348 40.8705 40.908 40.7919C39.6995 40.7734 38.3702 40.8373 37.1124 40.8558C36.4758 40.8705 35.84 40.8847 35.2066 40.8994C34.5789 40.9311 33.9641 40.9931 33.3459 41.0381C32.3972 41.1101 31.4609 41.3222 30.526 41.3928L27.3994 49.6708H34.0053L35.666 45.4091H44.2939L45.846 49.6708H52.5245L49.4353 41.3298C49.1058 41.3033 48.7782 41.1357 48.4478 41.1096Z",
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M73.4002 46.1807C72.6658 45.934 71.8883 45.622 71.0506 45.3847C70.2172 45.1399 68.9367 44.8823 68.0221 44.6139C67.8685 44.5679 67.1475 44.522 67.1475 44.4756V49.6701H74.2587V46.471C74.2587 46.3772 73.6818 46.283 73.4002 46.1807Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2459 43.616C15.7448 43.7287 15.2527 43.8395 14.7691 43.9484C14.2936 44.0848 13.8266 44.2188 13.3696 44.35C11.5406 44.8789 9.84527 45.3226 8.39268 45.8652C6.9325 46.3847 5.62355 46.7635 4.60427 47.2176C3.24602 47.755 2.27652 48.1391 1.75977 48.3431C3.86138 49.4265 6.12087 50.0004 8.33863 50.0004C11.1182 50.0004 13.573 49.2073 15.3053 47.729C16.5512 46.6503 17.3259 45.1654 17.6207 43.2969C17.1571 43.4044 16.6972 43.5114 16.2459 43.616Z",
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M4.42842 46.826C5.40598 46.2625 6.6642 45.7374 8.09547 45.0953C8.48469 44.9329 8.88339 44.7463 9.29585 44.5626C8.96114 44.6473 8.59657 44.6994 8.19455 44.6994C6.35368 44.6994 4.6209 43.9423 2.67147 42.2476L0 47.2957C0.550886 47.6755 1.12121 48.0088 1.70101 48.3109C2.17889 48.051 3.10857 47.5448 4.42842 46.826Z",
  fill: "white"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 50,
    viewBox: "0 0 79 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c2c74489.svg";
export { ForwardRef as ReactComponent };